<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadUser="loadUser"
      :includeAdmin="true"
    ></results-bar>
    <results-summary
      v-if="summary"
      :id="doc.id"
      :model="model"
      :lang="lang"
    ></results-summary>
    <results-user
      v-if="!summary"
      :key="currentUser"
      :uid="currentUser"
      :id="doc.id"
      :model="model"
      :lang="lang"
    ></results-user>
  </div>
</template>

<script>
import {
  ResultsUser,
  ResultsBar,
  ResultsSummary,
} from "@/components/results/stakeholder";

export default {
  name: "PriorityResults",
  props: {
    doc: {
      type: Object,
      default: null,
    },
    model: String,
    lang: String,
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null,
    };
  },
  components: {
    ResultsUser,
    ResultsBar,
    ResultsSummary,
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
  },
};
</script>
